import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetafrenzyGuard } from 'ngx-metafrenzy';
import { UnsubscribeComponent } from './unsubscribe.component';

const routes: Routes = [
  {
    path: '',
    component: UnsubscribeComponent,
    canActivate: [MetafrenzyGuard],
    data: {
      metafrenzy: {
        title: $localize`:@@metaDataWipperozUnsubscribeTitle:Unsubscribe from notifications | Wipperoz`,
        tags: [
          {
            name: 'description',
            content: $localize`:@@metaDataWipperozUnsubscribeDescription:Unsubscribe from receiving notifications`
          }
        ]
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UnsubscribeRoutingModule {}
